/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ client: NonNullable<unknown> }} Mcp_Official_DocsInputs */

const en_mcp_official_docs = /** @type {(inputs: Mcp_Official_DocsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.client} setup docs`)
};

const es_mcp_official_docs = /** @type {(inputs: Mcp_Official_DocsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Documentación de configuración de ${i?.client}`)
};

/**
* | output |
* | --- |
* | "{client} setup docs" |
*
* @param {Mcp_Official_DocsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_official_docs = /** @type {((inputs: Mcp_Official_DocsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Official_DocsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_official_docs(inputs)
	return en_mcp_official_docs(inputs)
});